var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.9697C16.8252 20.9697 20.8154 16.9795 20.8154 12.1543C20.8154 7.32031 16.8252 3.33887 11.9912 3.33887C7.16602 3.33887 3.18457 7.32031 3.18457 12.1543C3.18457 16.9795 7.1748 20.9697 12 20.9697ZM12 19.8271C7.74609 19.8271 4.32715 16.3994 4.32715 12.1543C4.32715 7.90039 7.74609 4.47266 11.9912 4.47266C16.2451 4.47266 19.6729 7.90039 19.6816 12.1543C19.6816 16.3994 16.2539 19.8271 12 19.8271ZM7.13965 10.2383H16.8779C17.1768 10.2383 17.3965 10.0449 17.3965 9.74609C17.3965 9.45605 17.1768 9.2627 16.8779 9.2627H7.13965C6.83203 9.2627 6.62109 9.45605 6.62109 9.74609C6.62109 10.0449 6.83203 10.2383 7.13965 10.2383ZM8.43164 13.1387H15.5947C15.8848 13.1387 16.1045 12.9453 16.1045 12.6465C16.1045 12.3564 15.8848 12.1631 15.5947 12.1631H8.43164C8.12402 12.1631 7.9043 12.3564 7.9043 12.6465C7.9043 12.9453 8.12402 13.1387 8.43164 13.1387ZM9.77637 16.0566H14.2412C14.54 16.0566 14.7598 15.8545 14.7598 15.5645C14.7598 15.2744 14.54 15.0811 14.2412 15.0811H9.77637C9.46875 15.0811 9.25781 15.2744 9.25781 15.5645C9.25781 15.8545 9.46875 16.0566 9.77637 16.0566Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.6363c0211d1ef7d13a1ba7951e04d549.svg";
export { ForwardRef as ReactComponent };